import { Row } from '@tanstack/react-table'
import { MatterReadForTable } from '@/matter/store/schemas'

/**
 * Multi-term AND filter function for TanStack Table matters filtering.
 * Splits the search query by spaces and checks if ALL terms appear in the searchable text.
 *
 * @param row - The table row being filtered
 * @param _columnId - Column ID (required by TanStack Table signature, unused for global filters)
 * @param filterValue - The search query string
 *
 * @example
 * Search: "cat dog" → matches rows containing both "cat" AND "dog" (in any order, any column)
 * Search: "pet" → matches rows containing "pet"
 */
export function mattersMultiTermFilter(row: Row<MatterReadForTable>, _columnId: string, filterValue: string): boolean {
  if (!filterValue) return true

  // Get searchable text from the row (matter name and client)
  const matterName = (row.original.name || '').toLowerCase()
  const client = (row.original.client || '').toLowerCase()
  const searchableText = `${matterName} ${client}`

  // Split search query into terms and filter out empty strings
  const searchTerms = filterValue
    .toLowerCase()
    .split(/\s+/)
    .filter((term) => term.length > 0)

  // Check if ALL terms appear in the searchable text
  return searchTerms.every((term) => searchableText.includes(term))
}
